import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton, Translation, useResolver } from '@ps/web-shared-components';
import React from 'react';

import useWizardExit from '@swf/core/hooks/useWizardExit';

import laptop from '../..//assets/laptop.png';
import laptopbg from '../..//assets/laptopbg.png';
import mobile from '../..//assets/mobile.png';
import trPromptVideo from '../..//assets/video/tr-prompt-video.mp4';
import Prompt from '../Prompt/Prompt';

import {
  TXTCLI_Download_the_XXBrandXX_app_to__ELL,
  TXTCLI_Play_on_Web,
  TXTINS_The_home_of_online_poker,
  TXTMOB_Download_PokerStars
} from './TransitionalExitPrompt.messages.json';
import styles from './TransitionalExitPrompt.scss';

export type Handler = () => void;

const TransitionalExitPrompt: React.FC = () => {
  const exitWizard = useWizardExit();
  const downloadLink = useResolver(ResolverTag.PSDownload);
  const resolverPoker = useResolver(ResolverTag.WebPoker);

  return (
    <Prompt
      title={{ translation: TXTINS_The_home_of_online_poker }}
      primaryButton={{ translation: TXTCLI_Play_on_Web, href: resolverPoker }}
      primaryButtonVariant="secondary"
      variant="info"
      onClose={exitWizard}
      hasBackground
      isExitPrompt
    >
      <div className={styles.wrapper}>
        <p>
          <Translation {...TXTCLI_Download_the_XXBrandXX_app_to__ELL} />
        </p>
        <div className={styles.imagesWrapper}>
          <img src={laptop} alt="" />
          <img src={mobile} className={styles.imageMobile} alt="" />
          <video autoPlay loop muted className={styles.video} poster={laptopbg} playsInline>
            <source src={trPromptVideo} type="video/mp4" />
          </video>
        </div>
        <StarsButton
          target="_blank"
          rel="noopener noreferrer"
          href={downloadLink}
          variant="primary"
          className={styles.button}
          disabled={!downloadLink}
          translation={TXTMOB_Download_PokerStars}
          onClick={() => exitWizard()}
        />
      </div>
    </Prompt>
  );
};

export default TransitionalExitPrompt;
